import z from 'zod';
import { organizationDefRowSchema } from './organizationDefSchema.js';
import { timestampSchema } from './commonSchemas.js';
// Schema per AttributeTypeValue
export const attributeTypeValueSchema = z.enum([
    'number',
    'boolean',
    'date',
    // 'string_array', // eliminato per inconsistenza
    // 'number_array' // eliminato per inconsistenza
]);
// Schema per AttributeDef
export const attributeDefSchema = z.object({
    name: z.string(),
    description: z.string().optional().nullable(),
    type_value: attributeTypeValueSchema,
    special: z.enum([
        "age", // età calcolata
    ]).optional()
});
/**
 * Schema per AttributeDefRow
 * @db_table personal_attributes
 */
export const attributeDefRowSchema = z.object({
    id: z.number().describe('type:number,editable:false,label:ID'),
    organization_id: z.number().optional().describe('type:organization,label:Organizzazione'),
    // campi di attribute_data riportati qui in attesa di eliminare il jsonb
    name: z.string().describe('label:Titolo'),
    description: z.string().optional().nullable().describe('type:textarea,label:Descrizione'),
    type_value: attributeTypeValueSchema,
    special: z.enum([
        "age", // età calcolata
    ]).optional(),
    // fine campi di attribute_data
    attribute_data: attributeDefSchema,
    metadata: z.record(z.any()).optional(),
    is_core: z.boolean().optional(),
    created_at: timestampSchema.describe('type:datetime,editable:false,label:Data Creazione'),
    updated_at: timestampSchema.describe('type:datetime,editable:false,label:Data Modifica')
});
export const attributeDefRowSchemaNoId = attributeDefRowSchema.omit({ id: true, created_at: true, updated_at: true });
/**
 * Schema per AttributeDefRowView
 * @db_view personal_attributes_view
 */
export const attributeDefRowSchemaView = attributeDefRowSchema.extend({
    /** Nome attributo estratto da attribute_data per facilità di query */
    name: z.string(),
    /** Descrizione attributo estratta da attribute_data per facilità di query */
    description: z.string(),
    /** Tipo valore attributo estratto da attribute_data (number, boolean, date) */
    type_value: attributeTypeValueSchema,
    /** Informazioni complete organizzazione proprietaria espanse tramite get_organization_by_id() */
    organization_info: organizationDefRowSchema.extend({
        territorial_info: z.any().optional().nullable(), // JSON delle informazioni territoriali
    }).optional().nullable(),
    /** Nome completo organizzazione estratto per facilità di query e ordinamento */
    organization_name: z.string().optional().nullable()
});
//# sourceMappingURL=attributeDefSchema.js.map